"use strict";
// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
Object.defineProperty(exports, "__esModule", { value: true });
var coreutils_1 = require("@phosphor/coreutils");
/**
 * A runtime interface token for a widget registry.
 */
exports.IJupyterWidgetRegistry = new coreutils_1.Token('jupyter.extensions.jupyterWidgetRegistry');
